export default __webpack_public_path__ + "static/featured-articles-section_hero-desktop-3dedc90ff6f3522f1cb0929ed5b3e71b.jpg";